 export default {
  API_ENDPOINT: `https://floating-mountain-13173.herokuapp.com/api`,
  // API_ENDPOINT: `http://localhost:8000/api`,
   API_KEY: process.env.REACT_APP_API_KEY,
   TOKEN_KEY: "movienight-client-auth-token",
 };

 